<template>
  <div class="md:mb-10">
    <ShowEntryHeader templatename="shortshort" />

    <br /><br />
  </div>
</template>


<script>
import { usePartyStore } from "../../stores/PartyStore";
import ShowEntryHeader from "./../../components/ShowEntryHeader.vue";
export default {
  name: "TheShortShortEntry",
  components: {
    ShowEntryHeader,
  },
  data() {
    return {
      partyStore: null,
    };
  },
  computed: {
    party() {
      return this.partyStore.party;
    },

  }, 
  async created() {
    this.partyStore = usePartyStore();
  },
};
</script>